var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 14c0 7.73-6.27 14-14 14S0 21.73 0 14 6.27 0 14 0s14 6.27 14 14z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0v14l5.6 2.8L13.41 28H14c7.737 0 14-6.263 14-14S21.737 0 14 0z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 14c0 7.73-6.27 14-14 14S0 21.73 0 14 6.27 0 14 0s14 6.27 14 14z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0v14l5.6 2.8L13.41 28H14c7.737 0 14-6.263 14-14S21.737 0 14 0z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.488 7.7H14v9.1l-2.1-.7-9.688-9.618h-.014A13.96 13.96 0 0 1 14 0c5.46 0 10.185 3.136 12.488 7.7z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD2C00",
    d: "M2.21 6.485 8.4 16.888l3.5-.788z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#558B2F",
    d: "m13.41 28 6.254-11.241L16.8 14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9A825",
    d: "M26.506 7.7H14l-1.105 3.206z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3 14c0 3.478-2.822 6.3-6.3 6.3A6.301 6.301 0 0 1 7.7 14c0-3.478 2.822-6.3 6.3-6.3 3.478 0 6.3 2.822 6.3 6.3z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9 14a4.9 4.9 0 0 1-4.9 4.9A4.9 4.9 0 0 1 9.1 14 4.9 4.9 0 0 1 14 9.1a4.9 4.9 0 0 1 4.9 4.9z",
    fill: "#2196F3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.9767c81f.svg";
export { ForwardRef as ReactComponent };